// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"65468038","353":"65b54ea2"}[chunkId] + ".js";
};